<template>
  <div class="modal">
    <div class="modal-content product-pricing-modal">
      <p class="btn" v-on:click="closeModal">x</p>
      <p>Confirm?</p>
      <form v-on:submit.prevent="handleSubmit">
        <input type="number" class="search" setp="0.01" name="" v-model="refundAmount">
        <div class="submit">
          <button type="submit" class="btn" v-show="refundAmount !== null && refundAmount >= 0">Submit</button>
          <button v-on:click="closeModal" class="close btn">Back</button>
        </div>
      </form>
    </div>

  </div>
</template>

<script>
export default {
  props: {
    onSubmit: {
      type: Function,
      default: ()=>{}
    },
    closeModal: {}
  },
  data() {
    return {
        refundAmount: null
    }
  },
  methods: {
    handleSubmit() {
      this.onSubmit(this.refundAmount)
      this.closeModal()
    }
  }
}
</script>

<style>

</style>